import { render, staticRenderFns } from "./appletConfig.vue?vue&type=template&id=89ac9f2c&scoped=true&"
import script from "./appletConfig.vue?vue&type=script&lang=js&"
export * from "./appletConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ac9f2c",
  null
  
)

export default component.exports